/**
 * Reads the browser's marketing-consent cookie and, only when it is
 * `granted`, the Meta `_fbp` / `_fbc` cookies (or an fbclid on this URL).
 *
 * Nothing in the app or on www sets that cookie today, so this returns null
 * and Conversions API calls go out without match keys.
 */

import { collectMetaMatch, type MetaMatch } from "@orsane/util/metaAds";

export function collectMetaMatchFromBrowser(): MetaMatch | null {
    try {
        if (typeof document === "undefined" || typeof window === "undefined") {
            return null;
        }
        return collectMetaMatch({
            cookieString: document.cookie,
            search: window.location.search,
            hostname: window.location.hostname,
        });
    } catch {
        return null;
    }
}
